module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('section', {
    staticClass: "posts"
  }, [_c('div', {
    staticClass: "container"
  }, [_c('div', {
    staticClass: "columns"
  }, [_c('div', {
    staticClass: "column is-half is-offset-one-quarter"
  }, [_c('h2', {
    staticClass: "title"
  }, [_vm._v("Posts")]), _vm._v(" "), _vm._l((_vm.posts), function(post, index) {
    return _c('div', {
      staticClass: "box"
    }, [_c('PostItem', {
      attrs: {
        "post": post,
        "index": index
      }
    })], 1)
  })], 2)])])])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-b8e90dd6"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/PostList.vue
// module id = 178
// module chunks = 1